module.exports = __webpack_public_path__ + "static/media/promo-space.251958f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/promo-space.jpg
// module id = 319
// module chunks = 0